module.exports = __webpack_public_path__ + "static/img/therezia.f72cb90.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/therezia.jpeg
// module id = 9cEd
// module chunks = 1